import { render, staticRenderFns } from "./rateAndScore.vue?vue&type=template&id=4cf2ac25&scoped=true"
import script from "./rateAndScore.vue?vue&type=script&lang=js"
export * from "./rateAndScore.vue?vue&type=script&lang=js"
import style0 from "./rateAndScore.vue?vue&type=style&index=0&id=4cf2ac25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2ac25",
  null
  
)

export default component.exports